<template>
	<div slot="body">
		<div class="flex flex_column text_left modal-content">
			<div class="flex">
				<template v-if="!showOnlyDocuments">
					<div class="flex_2 base_padding">
						<h4 class="info_title">{{ getDetailType(info.type) }}</h4>
						<md-field displayOnly>
							<label>{{ $t("common.supplier") }}</label>
							<md-input :value="info.supplierName" disabled></md-input>
						</md-field>
						<md-field displayOnly v-if="!info.contact">
							<label>{{ $t("common.debtor") }}</label>
							<md-input :value="info.debtorName" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.invoiceDate") }}</label>
							<md-input :value="info.invoiceDate" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.invoiceNumber") }}</label>
							<template v-if="info.invoiceDocument">
								<md-input :value="info.invoiceNumber" disabled></md-input>
							</template>
							<template v-else>
								<md-input :value="info.invoiceNumber" disabled></md-input>
							</template>
						</md-field>
						<md-field v-if="info.installmentContractNumber" displayOnly>
							<label>{{ $t("common.contractNumber") }}</label>
							<md-input :value="info.installmentContractNumber" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.totalAmount") }}</label>
							<md-input :value="formatMoney(info.amount)" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.label.currency") }}</label>
							<md-input :value="info.currency" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.dueDate") }}</label>
							<md-input :value="info.dueDate" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("seller.upload.ApplicableLaw") }}</label>
							<md-input :value="info.applicableLaw" disabled></md-input>
						</md-field>
						<!-- Should be enabled later again, when we enable automatic clearing as debtor preset-->
						<!--
												<md-field  displayOnly v-if="info.automaticClearingPayment!= null">
													<label>{{$t("ReceivableDetailsModal.Automated.clearing")}}</label>
													<md-input :value="yesFun(info.automaticClearingPayment)" disabled></md-input>
												</md-field>
											 -->
					</div>
					<div class="flex_2 base_padding" v-if="info.contact">
						<h4 class="info_title">{{ $t("common.debtor") }}</h4>
						<md-field displayOnly>
							<label>{{ $t("common.company") }}</label>
							<md-input :value="info.debtorName" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("ReceivableDetailsModal.Contact.name") }}</label>
							<md-input :value="info.contact.name"></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("common.phone") }}</label>
							<md-input :value="info.contact.phone" disabled></md-input>
						</md-field>
						<md-field displayOnly>
							<label>{{ $t("user.sendEmail.email") }}</label>
							<md-input :value="info.contact.email" disabled></md-input>
						</md-field>
					</div>
				</template>
				<div class="flex_1 base_padding" v-if="info.invoiceDocument || hasAdditionalDocuments">
					<h4 v-if="!showOnlyDocuments" class="info_title">{{ $t("common.documents") }}</h4>
					<div v-if="info.invoiceDocument" style="margin-bottom: 2rem">
						<h5 class="info_title" style="margin-bottom: 1rem">{{ $t("common.invoiceDocument") }}</h5>
						<a :href="getFileDownloadUrl(info.invoiceDocument)" target="_blank">{{ info.invoiceDocumentFilename }}</a>
					</div>
					<div v-if="hasAdditionalDocuments">
						<h5 class="info_title" style="margin-bottom: 1rem">{{ $t("common.otherDocuments") }}</h5>
						<a v-for="(fileInfo) in info.additionalDocuments" :href="getFileDownloadUrl(fileInfo.fileId)" target="_blank" style="display: block">{{ fileInfo.fileName }}</a>
					</div>
				</div>
			</div>
			<div v-if="isBundle && !showOnlyDocuments" class="base_padding">
				<h4 class="info_title">{{ $t("common.subReceivablesList") }}</h4>
				<AgItem :column-defs="subReceivablesColumnDefs"
						:row-data="info.bundledSubReceivables"
						height-type="matchRows"
						min-height="124px"
				></AgItem>
			</div>
		</div>

		<div class="flex flex_end base_padding">
			<md-button class="md-blank" @click.stop="closeNoticeModal">{{ $t("common.close") }}</md-button>
		</div>
	</div>
</template>
<script>
import {receivableApi} from "@/common/api/receivableApi";
import {mapGetters} from "vuex";
import {fileuploadApi} from "@/common/api/fileuploadApi";
import {formatAsLocalizedDate} from "@/common/format";
import AgItem from "@/components/templates/agGrid/AgItem";
import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import {enumDef} from "@/common/enumDefs";

export default {
	components: { AgItem },
	data() {
		return {
			info: {},
			subReceivablesColumnDefs: [
				{
					headerName: this.$t("common.invoiceDate"),
					field: "invoiceDateNewFormat",
					flex: 1,
					valueFormatter: asLocalizedDate(),
					sortable: false
				},
				{
					headerName: this.$t("common.invoiceNumber"),
					field: "invoiceNumber",
					flex: 1,
					cellRendererFramework: "FileLink",
					cellRendererParams: {
						fileIdField: "invoiceDocument"
					},
					sortable: false
				},
				{
					headerName: this.$t("common.amount"),
					field: "amount",
					flex: 1,
					valueFormatter: asMoneyAmount({ currencyField: "currency" }),
					sortable: false
				},
				{
					headerName: this.$t("common.dueDate"),
					field: "dueDateNewFormat",
					flex: 1,
					valueFormatter: asLocalizedDate(),
					sortable: false
				}
			]
		};
	},
	created() {
		let { data } = this.noticeModalData;
		this.getDetail(data.receivableId || data.id);
	},
	methods: {
		closeNoticeModal() {
			this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
		},
		getDetail(id) {
			receivableApi
				.receivableDetail(id)
				.then(res => {
					this.info = {
						...res,
						invoiceDate: formatAsLocalizedDate(res.invoiceDateNewFormat),
						dueDate: formatAsLocalizedDate(res.dueDateNewFormat),
					};

					if (this.isBundle) {
						this.info.bundledSubReceivables.sort((r1, r2) => r1.invoiceDate.localeCompare(r2.invoiceDate));
					}
				})
				.catch(err => {
					this.toast(err);
				})
				.finally(() => this.$emit("ready", this));
		},
		getFileDownloadUrl(fileId) {
			return fileuploadApi.getPdfUrl(fileId);
		}
	},
	computed: {
		...mapGetters({ noticeModalData: "noticeModalData" }),
		showOnlyDocuments() {
			return this.noticeModalData.data.showOnlyDocuments;
		},
		isBundle() {
			return this.info.type === enumDef.receivableType.TbBundle;
		},
		adjustedWidth() {
			return this.info.contact ? 1000 : null;
		},
		hasAdditionalDocuments() {
			return this.info.additionalDocuments && this.info.additionalDocuments.length > 0;
		}
	}
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/base_variables.scss";

input.withLink {
	cursor: pointer;
	-webkit-text-fill-color: $accent_color !important;
}

.info_group {
	display: flex;
	margin: 10px 0;

	label {
		width: 150px;
	}

	p {
		flex: 1;
	}
}
</style>
